import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ variables,palette }: Theme) => ({
  orderCardBody: {
    display: 'flex',
    justifyContent: 'space-between',
    //minHeight: '70px',
    marginBottom: variables?.spacingA,
    '& .elipsis': {
      width: '200px',
      wordBreak: 'break-word'
    }
  },
  orderCardBodyLeft: {
    display:'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  orderCardBodyLeftContent: {
    marginLeft: variables?.spacingB,
  },
  orderCardBodyRight: {
    display:'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  orderCardBodyRightTime:{
    display: 'flex',
    justifyContent: 'row',
    gap: variables?.spacingA
  },

  orderCardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width:'100%',
    '& .details-btn': {
      right: 0,
      backgroundColor: palette.jet?.interactiveSecondary,
      padding: variables?.spacingB,
      width:'32px',
      height:'32px'
    },
    
  },
  orderCardCourierInfo: {
    display:'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: variables?.spacingB
  },
  orderCardSub: {
    display:'flex',
    justifyContent: 'space-between',
    paddingBottom:  variables?.spacingB
  },
  orderCardSubNote: {
    
  },
  orderCardSubRightClient: {
    display: 'flex',
    flexDirection: 'row',
    gap: variables?.spacingA,
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
    '& p':{
       maxWidth: '200px',
       wordBreak: 'break-all'
    }
  },
  itemNoData: {
    display: 'flex',
    width: '100%',
    padding: variables?.spacingD,
    justifyContent: 'center',
    alignItems: 'center',
  },
  orderCardContent: {
    marginBottom: variables?.spacingC,
    '&:hover': {
      cursor: 'pointer',
      borderColor: palette.jet?.borderInverse,
    },
    '&.active': {
      border:`2px solid ${palette.jet?.supportInfoInverse}`,
      borderRadius:'12px',
      '& > *:hover': {
        borderColor:'0'
      }
    }
  },
  orderCardDetailWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    gap: variables?.spacingC,
  }

}));

export default styles;
